import { render, staticRenderFns } from "./QueryBuilderGroup.vue?vue&type=template&id=572744b9&"
import script from "./QueryBuilderGroup.vue?vue&type=script&lang=js&"
export * from "./QueryBuilderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports